import { useRouter } from "next/router";
import DiscountAlertBanner from "./DiscountAlertBanner";
import DiscountAlertText from "./DiscountAlertText";
import { useEffect, useState, useRef } from "react";
import QuoteModel from "./QuoteModel";
import axios from "axios";

const CTABanner = ({ customStaticBannerComponentData, isds }) => {
  const router = useRouter();
  const [isPopover, setPopover] = useState(false);
  const contentRef = useRef(null);

  const handlePopover = () => setPopover((prev) => !prev);

  // Add click event listener for HTML content
  useEffect(() => {
    const handleHTMLClick = (e) => {
      // Check if clicked element or its parent has data-trigger-quote attribute
      const target = e.target.closest('[data-trigger-quote="true"]');
      if (target) {
        e.preventDefault();
        e.stopPropagation();
        console.log("Quote trigger clicked!"); // Debug log
        setPopover(true);
      }
    };

    // Attach listener to the document for better compatibility
    document.addEventListener("click", handleHTMLClick);

    return () => {
      document.removeEventListener("click", handleHTMLClick);
    };
  }, []);

  // Determine which banner data to use
  const useCustomBanner =
    customStaticBannerComponentData?.showGlobalBanner === false;

  if (useCustomBanner) {
    // Use custom banner data
    const customData = customStaticBannerComponentData;
    if (!customData || !customData?.bannerType) {
      return null;
    }

    const renderCustomBanner = () => {
      switch (customData?.bannerType) {
        case "text":
          return (
            <button onClick={handlePopover}>
              <DiscountAlertText content={customData?.textContent || {}} />
            </button>
          );
        case "image":
          return (
            <button onClick={handlePopover}>
              <DiscountAlertBanner content={customData.imageContent || {}} />
            </button>
          );
        default:
          return null;
      }
    };

    return (
      <>
        {renderCustomBanner()}
        {isPopover && (
          <QuoteModel opened={isPopover} setPopover={setPopover} isds={isds} />
        )}
      </>
    );
  } else {
    // Use global banner data
    const [bannerData, setBannerData] = useState<any>(null);
    const [showGlobalBanner, setShowGlobalBanner] = useState(false);

    const getGlobalbannerData = async () => {
      const {
        data: { data = [] },
      } = await axios.post("/api/strapi/get-global-static-banner");
      const result = data?.[0]?.attributes;
      const directoryName = result?.directoryName;
      const isActive = result?.isActive;
      const isAllowedDirectory =
        directoryName &&
        currentDirectory &&
        directoryName?.includes(currentDirectory);
      setBannerData(result || null);
      if (isActive && isAllowedDirectory) {
        setShowGlobalBanner(true);
      }
    };

    useEffect(() => {
      getGlobalbannerData();
    }, []);

    const [contentData, setContentData] = useState<any>({});

    // Extract current directory from router pathname
    const pathSegments = router?.asPath.split("/").filter(Boolean);
    const currentDirectory = pathSegments?.[0];

    useEffect(() => {
      if (bannerData?.content) {
        const result =
          Array.isArray(bannerData?.content) &&
          bannerData?.content?.reduce((acc, element) => {
            if (element["__component"] === "cta-nudge.image-based-banner") {
              acc["imageContent"] = element;
            } else if (element["__component"] === "cta-nudge.html-content") {
              acc["htmlContent"] = element?.content;
            } else {
              acc["textContent"] = element;
            }
            return acc;
          }, {});
        setContentData(result);
      }
    }, [bannerData?.content]);

    const renderGlobalBanner = () => {
      switch (bannerData?.bannerType) {
        case "text":
          return (
            <button onClick={handlePopover}>
              <DiscountAlertText content={contentData?.textContent || {}} />
            </button>
          );
        case "image":
          return (
            <button onClick={handlePopover}>
              <DiscountAlertBanner content={contentData?.imageContent || {}} />
            </button>
          );
        default:
          return null;
      }
    };

    return (
      <>
        {showGlobalBanner && renderGlobalBanner()}
        {isPopover && (
          <QuoteModel opened={isPopover} setPopover={setPopover} isds={isds} />
        )}
      </>
    );
  }
};

export default CTABanner;
